const HeartEmoji = () => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="heart-emoji"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.99 49.84L13.16 33L11.48 31.31C6.83 26.67 6.83 19.13 11.48 14.49C16.13 9.84 23.66 9.84 28.31 14.49L29.99 16.17L31.67 14.49C36.32 9.84 43.85 9.84 48.5 14.49C53.15 19.14 53.15 26.67 48.5 31.32L29.98 49.84H29.99Z"
      fill="white"
    />
    <path
      d="M19.9 11C22.95 11 25.99 12.16 28.32 14.49L30 16.17L31.68 14.49C34 12.17 37.05 11 40.1 11C43.15 11 46.19 12.16 48.52 14.49C53.17 19.14 53.17 26.67 48.52 31.32L30 49.84L13.16 33L11.48 31.31C6.83 26.67 6.83 19.13 11.48 14.49C13.8 12.17 16.85 11 19.9 11ZM19.9 9C16.19 9 12.7 10.45 10.07 13.07C4.65 18.49 4.65 27.31 10.07 32.73L11.67 34.33C11.67 34.33 11.72 34.39 11.75 34.41L28.58 51.24C28.96 51.62 29.46 51.83 29.99 51.83C30.52 51.83 31.03 51.62 31.4 51.24L49.92 32.72C55.34 27.3 55.34 18.48 49.92 13.06C47.3 10.45 43.8 9 40.09 9C36.38 9 32.89 10.45 30.26 13.07L29.99 13.34L29.72 13.07C27.1 10.45 23.61 9 19.9 9Z"
      fill="#004628"
    />
  </svg>
)

export default HeartEmoji
